import FetchClient from "./FetchClient";

export interface BlogDeal {
  name: string;
  image: string;
  price: number;
  msrp: number;
  discount: number;
  upc: string;
  url: string;
  category: string;
  storeId: string;
  dealId: string;
}

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  body: string;
  retailer: string;
  coverImage: string;
  deals: BlogDeal[];
  tags: string[];
  publishedAt: number;
  createdAt: number;
  status: string;
}

const RETAILER_LABELS: Record<string, string> = {
  walmart: "Walmart",
  target: "Target",
  bestbuy: "Best Buy",
  home_depot: "Home Depot",
  dollar_general: "Dollar General",
  costco: "Costco",
};

export function retailerLabel(key: string): string {
  return RETAILER_LABELS[key] || key;
}

export async function getPublishedBlogs(limit = 20): Promise<BlogPost[]> {
  return FetchClient.get<BlogPost[]>(`/public/blogs?limit=${limit}`, {}, true);
}

export async function getBlogBySlug(slug: string): Promise<BlogPost> {
  return FetchClient.get<BlogPost>(`/public/blogs/${slug}`, {}, true);
}
